var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLove(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 3.87591C14 8.25195 7.51312 11.794 7.23687 11.9403C7.16406 11.9795 7.08268 12 7 12C6.91732 12 6.83594 11.9795 6.76312 11.9403C6.48688 11.794 0 8.25195 0 3.87591C0.00115796 2.84831 0.409788 1.86313 1.13624 1.13651C1.86269 0.409884 2.84764 0.00115823 3.875 0C5.16563 0 6.29562 0.555131 7 1.49348C7.70438 0.555131 8.83438 0 10.125 0C11.1524 0.00115823 12.1373 0.409884 12.8638 1.13651C13.5902 1.86313 13.9988 2.84831 14 3.87591Z",
    fill: "#E11616"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLove);
export default __webpack_public_path__ + "static/media/Love.688768f76cfbf9c46b03ea54f1b7e69f.svg";
export { ForwardRef as ReactComponent };